import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import TrackFilterItem from 'components/track-statistics/track-filter-item/TrackFilterItem';

import request from 'actions/request';
import transmit from 'actions/transmit';

class TrackFilter extends Component {
  constructor(props) {
    super(props);

    const fields = [
      ['recorder-type', 'track-filter-recorder-type', I18n.t('trackStatistics.trackFilter.recorderType'), ''],
      ['vehicle', 'track-filter-vehicle',  I18n.t('trackStatistics.trackFilter.vehicle'), ''],
      ['track', 'track-filter-track',  I18n.t('trackStatistics.trackFilter.name'), ''],
      ['origin', 'track-filter-departure-airport',  I18n.t('trackStatistics.trackFilter.origin'), 'DDDD'],
      ['destination', 'track-filter-arrival-airport',  I18n.t('trackStatistics.trackFilter.destination'), 'AAAA'],
      ['from-date', 'track-filter-from-date',  I18n.t('trackStatistics.trackFilter.departureFromDate'), 'YYYY/mm/dd'],
      ['to-date', 'track-filter-to-date',  I18n.t('trackStatistics.trackFilter.departureToDate'), 'YYYY/mm/dd']
    ];

    this.trackFilterItems = fields.map((field) =>
      <TrackFilterItem
        key={field[1]}
        propName={field[0]}
        id={field[1]}
        label={field[2]}
        placeholder={field[3]}
        changeTrackFilterItem={ this.changeTrackFilterItem.bind(this) }
      />
    );
  }

  changeTrackFilterItem(payload) {
    this.props.transmit(
      'CHANGE_TRACK_FILTER_ITEM',
      payload
    )
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.request(
      ['trackStatistics', 'getParams'],
      'post',
      'TRACK_STATISTICS_PARAMS',
      { trackFilter: this.props.trackFilter }
    );
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <p><b><Translate value='trackStatistics.trackFilter.trackInfoFilter'/></b></p>
        { this.trackFilterItems }
        <div className='form-group'>
          <input type='submit' className='btn btn-default' value={ I18n.t('trackStatistics.trackFilter.apply') }/>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    trackFilter: state.trackFilter
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackFilter);
